export const BASE_URL = () => {
  // 使用环境变量中定义的API地址，如果未定义则使用默认值
  return process.env.VUE_APP_BASE_API || 'http://180.178.36.66:8002/addons/bankflow'
  // console.log('[process.env.VUE_APP_BASE_API]', process.env.VUE_APP_BASE_API)
  return process.env.VUE_APP_BASE_API || 'http://192.168.31.34:8002/addons/bankflow'
}

export const API = {
  USER_LIST: '/user/list',
  USER_INFO: '/user/info',
  USER_CREATE: '/user/create',
  USER_ADD: '/user/add',
  USER_UPDATE: '/user/update',
  USER_DELETE: '/user/delete',
  USER_COPY: '/user/copy',
  USER_SET_STATUS: '/user/setStatus',

  // 转账记录相关接口
  TRANSFER_RECORD: '/transfer_record/list1',
  TRANSFER_RECORD_CHART: '/transfer_record/chart',
  CALCULATE_BALANCE: '/transfer_record/calculatesBalance',
  DELETE_RECORDS: '/transfer_record/del',
  DELETE_ALL_RECORDS: '/transfer_record/delAll', // 清空用户所有记录
  EDIT_RECORD: '/transfer_record/edit',
  REPLACE_RECORD_FIELD: '/transfer_record/replaceField',
  GET_FIRST_AND_LAST_DATE: '/transfer_record/getFirstAndLastDate',
  ADD_RECORD: '/transfer_record/add',
  COPY_RECORDS: '/transfer_record/copy',
  // 批量修改
  BATCH_EDIT_RECORD: '/transfer_record/batchEdit',
  // 利率管理相关接口
  INTEREST_RATE_LIST: '/interest_rate/index',
  INTEREST_RATE_INFO: '/interest_rate/info',
  INTEREST_RATE_SAVE: '/interest_rate/save',
  
  // 批量生成配置相关接口
  BATCH_GENERATE_GET_FIXED_CONFIG_LIST: '/batch_generate/getFixedConfigList',
  BATCH_GENERATE_ADD_FIXED_CONFIG: '/batch_generate/addFixedConfig',
  BATCH_GENERATE_EDIT_FIXED_CONFIG: '/batch_generate/editFixedConfig',
  BATCH_GENERATE_DELETE_FIXED_CONFIG: '/batch_generate/deleteFixedConfig',
  BATCH_GENERATE_ADD_RANDOM_CONFIG: '/batch_generate/addRandomConfig',
  BATCH_GENERATE_EDIT_RANDOM_CONFIG: '/batch_generate/editRandomConfig',
  BATCH_GENERATE_DELETE_RANDOM_CONFIG: '/batch_generate/deleteRandomConfig',
  BATCH_GENERATE: '/batch_generate/generate',
  BATCH_GENERATE_IMPORT_CONFIG: '/batch_generate/importConfig',
  EXPORT_FIXED_CONFIG_EXCEL: '/batch_generate/exportFixedConfigExcel',
  EXPORT_RANDOM_CONFIG_EXCEL: '/batch_generate/exportRandomConfigExcel',
  IMPORT_FIXED_CONFIG_EXCEL: '/batch_generate/importFixedConfigExcel',
  IMPORT_RANDOM_CONFIG_EXCEL: '/batch_generate/importRandomConfigExcel',
  // 公式预设库
  FORMULA_LIST: '/formula/index',
  // 打印模板相关接口
  PRINT_TEMPLATE_LIST: '/print_template/list',
  PRINT_TEMPLATE_ADD: '/print_template/add',
  PRINT_TEMPLATE_EDIT: '/print_template/edit',
  PRINT_TEMPLATE_DELETE: '/print_template/del',
  PRINT_TEMPLATE_PRINT: '/print_template/print',

  // 文件上传接口
  UPLOAD: '/index/upload',

  // 印章管理相关接口
  GET_SEAL_INFO: '/seal/info',
  ADD_SEAL: '/seal/add',
  UPDATE_SEAL: '/seal/edit',
  DELETE_SEAL: '/seal/del',

  // 登录鉴权相关接口
  AUTH_LOGIN: '/auth/login',
  AUTH_LOGOUT: '/auth/logout',
  AUTH_USERINFO: '/auth/userinfo',
  AUTH_CHANGEPWD: '/auth/changepwd',
}
